/* MERCADO 2.0 — cart drawer, cart page and quick buy (owner: commerce components, Agent D). Docs: docs/components.md
   Modern Beauty Pop: drawer slides 280ms, quick-buy sheet rises 320ms, bag count bumps once (160ms) on change.
   API: MC2.cart.{add, change, open, close, refresh, note} · MC2.quickBuy.{open, close}
   - Every cart write runs in one queue (no overtaking taps), then the drawer (and the cart page section, if present)
     is re-rendered by the server through Section Rendering, so totals and discounts are always Shopify's own.
   - Lines are changed by line item KEY, never by index.
   - URLs respect Shopify.routes.root (/en/, /he/).
   - Events on document: mc2:cart:updated {cart, source} · mc2:cart:error {message, source} ·
     mc2:cart:opened / mc2:cart:closed · mc2:quickbuy:opened / mc2:quickbuy:closed {handle}
   No jQuery, no eval, no tracking (Shopify emits product_added_to_cart for Ajax cart calls). */
(function () {
  'use strict';
  var MC2 = (window.MC2 = window.MC2 || {});
  if (MC2.cart && MC2.cart.__mc2) return;

  var doc = document, html = doc.documentElement;
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function url(path) { return root() + path.replace(/^\//, ''); }
  var DRAWER_ID = 'mc2-cart-drawer';

  /* ---------- strings (rendered by sections/mc2-cart-drawer.liquid) ---------- */
  var FALLBACK = {
    ar: { error: 'تعذّر تحديث السلة. حاولي مرة أخرى.', network: 'لا يوجد اتصال بالإنترنت. تحقّقي من الاتصال وحاولي مجدداً.', soldOut: 'نفدت الكمية', adding: 'جارٍ الإضافة…', added: 'أُضيفت للسلة', loading: 'جارٍ التحميل…', loadError: 'تعذّر تحميل الخيارات.', updating: 'جارٍ تحديث السلة…', updated: 'تم تحديث السلة', details: 'تفاصيل المنتج', close: 'إغلاق', noteSaved: 'تم حفظ الملاحظة', maxStock: 'هذه كل الكمية المتوفرة حالياً.' },
    he: { error: 'לא הצלחנו לעדכן את הסל. נסו שוב.', network: 'אין חיבור לאינטרנט. בדקו את החיבור ונסו שוב.', soldOut: 'אזל מהמלאי', adding: 'מוסיפים…', added: 'נוסף לסל', loading: 'טוען…', loadError: 'לא הצלחנו לטעון את האפשרויות.', updating: 'מעדכנים את הסל…', updated: 'הסל עודכן', details: 'לפרטי המוצר', close: 'סגירה', noteSaved: 'ההערה נשמרה', maxStock: 'זו כל הכמות שיש כרגע במלאי.' },
    en: { error: 'We couldn’t update your bag. Please try again.', network: 'You seem to be offline. Check your connection and try again.', soldOut: 'Sold out', adding: 'Adding…', added: 'Added to bag', loading: 'Loading…', loadError: 'We couldn’t load the options.', updating: 'Updating your bag…', updated: 'Bag updated', details: 'Product details', close: 'Close', noteSaved: 'Note saved', maxStock: 'That’s all we have in stock right now.' }
  };
  var strings = null;
  function t(key) {
    if (!strings) {
      strings = {};
      var el = doc.querySelector('script[data-mc2-cart-i18n]');
      if (el) { try { strings = JSON.parse(el.textContent) || {}; } catch (e) { strings = {}; } }
    }
    if (strings[key]) return strings[key];
    var lang = (html.getAttribute('lang') || 'ar').slice(0, 2).toLowerCase();
    return (FALLBACK[lang] || FALLBACK.ar)[key] || FALLBACK.en[key] || '';
  }

  /* ---------- helpers ---------- */
  function emit(name, detail) { doc.dispatchEvent(new CustomEvent(name, { detail: detail || {} })); }
  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }
  var liveEl;
  function announce(msg) {
    if (!msg) return;
    if (!liveEl) {
      liveEl = doc.createElement('p');
      liveEl.className = 'mc2-visually-hidden';
      liveEl.setAttribute('role', 'status');
      liveEl.setAttribute('aria-live', 'polite');
      doc.body.appendChild(liveEl);
    }
    liveEl.textContent = '';
    setTimeout(function () { liveEl.textContent = msg; }, 50);
  }
  function CartError(message, status) { var e = new Error(message || t('error')); e.status = status || 0; return e; }

  function request(method, path, body) {
    var opts = { method: method, credentials: 'same-origin', headers: { Accept: 'application/json' } };
    if (body) { opts.headers['Content-Type'] = 'application/json'; opts.body = JSON.stringify(body); }
    return fetch(url(path), opts).then(function (r) {
      return r.text().then(function (txt) {
        var data = null;
        try { data = txt ? JSON.parse(txt) : null; } catch (e) { data = null; }
        if (!r.ok) {
          var msg = '';
          if (data) {
            if (typeof data.description === 'string' && data.description) msg = data.description;
            else if (typeof data.message === 'string' && data.message && !/^cart error$/i.test(data.message)) msg = data.message;
            else if (data.errors && typeof data.errors === 'object') msg = Object.keys(data.errors).map(function (k) { return [].concat(data.errors[k]).join(' '); }).join(' ');
          }
          throw CartError(msg || t('error'), r.status);
        }
        if (data === null) throw CartError(t('error'), r.status);
        return data;
      });
    }, function () { throw CartError(t('network'), 0); });
  }
  /* /cart/change.js may report total_price including a delivery estimate; /cart.js never does. Normalise. */
  function normalise(cart) {
    if (cart && typeof cart.original_total_price === 'number' && typeof cart.total_discount === 'number') {
      cart.total_price = cart.original_total_price - cart.total_discount;
    }
    return cart;
  }

  /* ---------- write queue ---------- */
  var queue = Promise.resolve(), pending = 0;
  function enqueue(job) {
    pending++;
    setBusy(true);
    var run = queue.then(job, job);
    queue = run.then(done, done);
    function done() { pending--; if (!pending) { setBusy(false); flushCheckout(); } }
    return run;
  }
  function setBusy(on) {
    html.classList.toggle('mc2-cart-busy', on);
    $$('[data-mc2-cart-inner]').forEach(function (el) { if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy'); });
    $$('[data-mc2-checkout]').forEach(function (b) { if (on) b.setAttribute('aria-disabled', 'true'); else b.removeAttribute('aria-disabled'); });
  }
  var heldForm = null;
  function flushCheckout() {
    if (!heldForm) return;
    var f = heldForm; heldForm = null;
    var btn = $('[data-mc2-checkout]', f);
    if (f.requestSubmit && btn) f.requestSubmit(btn); else { var h = doc.createElement('input'); h.type = 'hidden'; h.name = 'checkout'; h.value = '1'; f.appendChild(h); f.submit(); }
  }

  /* ---------- section rendering ---------- */
  function sectionIds() {
    var ids = [DRAWER_ID];
    $$('[data-mc2-cart-section]').forEach(function (el) {
      var id = el.getAttribute('data-mc2-cart-section');
      if (id && ids.indexOf(id) === -1) ids.push(id);
    });
    return ids.slice(0, 5);
  }
  function renderSections(sections) {
    if (!sections) return;
    Object.keys(sections).forEach(function (id) {
      var markup = sections[id];
      if (typeof markup !== 'string') return;
      var target = id === DRAWER_ID ? $('[data-mc2-cart-section="' + DRAWER_ID + '"]') : $('[data-mc2-cart-section="' + id + '"]');
      if (!target) return;
      var tmp = doc.createElement('div');
      tmp.innerHTML = markup;
      var freshInner = $('[data-mc2-cart-inner]', tmp), inner = $('[data-mc2-cart-inner]', target);
      if (!freshInner || !inner) return;
      var hadFocus = inner.contains(doc.activeElement) ? focusKey(doc.activeElement) : null;
      var scroller = $('[data-mc2-scroll]', inner), top = scroller ? scroller.scrollTop : 0;
      inner.innerHTML = freshInner.innerHTML;
      inner.setAttribute('data-mc2-count', freshInner.getAttribute('data-mc2-count') || '0');
      var newScroller = $('[data-mc2-scroll]', inner);
      if (newScroller) newScroller.scrollTop = top;
      if (hadFocus) restoreFocus(inner, hadFocus);
      var title = $('[data-mc2-cart-title]', tmp), titleNow = $('[data-mc2-cart-title]', target);
      if (title && titleNow) titleNow.innerHTML = title.innerHTML;
    });
    var counter = $('[data-mc2-cart-section="' + DRAWER_ID + '"] [data-mc2-cart-inner]');
    if (counter) setCount(Number(counter.getAttribute('data-mc2-count')) || 0);
  }
  /* keep keyboard focus on the same control after a re-render */
  function focusKey(el) {
    var line = el.closest && el.closest('[data-mc2-line]');
    var role = el.getAttribute('data-mc2-focus');
    return role ? { line: line ? line.getAttribute('data-mc2-line') : null, role: role } : { role: 'heading' };
  }
  function restoreFocus(inner, k) {
    var el = null;
    if (k.line) {
      var line = $$('[data-mc2-line]', inner).filter(function (l) { return l.getAttribute('data-mc2-line') === k.line; })[0];
      if (line) el = $('[data-mc2-focus="' + k.role + '"]:not([disabled])', line) || $('[data-mc2-focus]:not([disabled])', line);
    }
    if (!el) el = $('[data-mc2-focus-fallback]', inner) || $('[data-mc2-line] [data-mc2-focus]', inner);
    if (!el) { var panel = inner.closest('[role="dialog"]'); el = panel; }
    if (el) { try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  }
  var reduceMotion = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  function setCount(n) {
    $$('[data-mc2-cart-count]').forEach(function (el) {
      var prev = (el.textContent || '').trim();
      el.textContent = String(n);
      if (el.hasAttribute('data-mc2-cart-count-hide-empty')) el.hidden = n === 0;
      /* one bump (scale 1.2, 160ms) when the number really changes */
      if (prev !== '' && prev !== String(n) && !reduceMotion) {
        el.classList.remove('mc2-bump');
        void el.offsetWidth;
        el.classList.add('mc2-bump');
        clearTimeout(el._mc2Bump);
        el._mc2Bump = setTimeout(function () { el.classList.remove('mc2-bump'); }, 200);
      }
    });
  }
  function fetchCart() { return request('GET', 'cart.js').then(normalise); }

  /* ---------- public cart API ---------- */
  function add(items, opts) {
    opts = opts || {};
    var list = (Array.isArray(items) ? items : [items]).map(function (i) {
      var o = { id: Number(i.id), quantity: Math.max(1, parseInt(i.quantity, 10) || 1) };
      if (i.properties) o.properties = i.properties;
      if (i.selling_plan) o.selling_plan = i.selling_plan;
      return o;
    });
    var source = opts.source || 'api';
    return enqueue(function () {
      return request('POST', 'cart/add.js', { items: list, sections: sectionIds().join(','), sections_url: location.pathname })
        .then(function (res) {
          renderSections(res && res.sections);
          var onCartPage = !!$('[data-mc2-main-cart]');
          if (opts.open !== false && !onCartPage) openDrawer();
          announce(t('added'));
          return fetchCart().catch(function () { return null; });
        })
        .then(function (cart) {
          if (cart) { setCount(cart.item_count); emit('mc2:cart:updated', { cart: cart, source: source }); }
          return cart;
        }, function (err) { emit('mc2:cart:error', { message: err.message, source: source }); throw err; });
    });
  }
  function change(key, quantity, opts) {
    opts = opts || {};
    var source = opts.source || 'drawer';
    return enqueue(function () {
      return request('POST', 'cart/change.js', { id: String(key), quantity: Math.max(0, parseInt(quantity, 10) || 0), sections: sectionIds().join(','), sections_url: location.pathname })
        .then(function (cart) {
          normalise(cart);
          renderSections(cart.sections);
          var want = Math.max(0, parseInt(quantity, 10) || 0);
          var item = (cart.items || []).filter(function (i) { return i.key === String(key); })[0];
          if (want > 0 && item && item.quantity < want) lineMessage(key, t('maxStock').replace('{n}', item.quantity));
          delete cart.sections;
          setCount(cart.item_count);
          announce(t('updated'));
          emit('mc2:cart:updated', { cart: cart, source: source });
          return cart;
        }, function (err) {
          emit('mc2:cart:error', { message: err.message, source: source });
          /* show the real quantities again, then the message on that line */
          return refreshNow().then(function () { lineMessage(key, err.message); throw err; }, function () { lineMessage(key, err.message); throw err; });
        });
    });
  }
  function refreshNow() {
    var ids = sectionIds();
    var sep = location.search ? '&' : '?';
    return Promise.all([
      fetch(location.pathname + location.search + sep + 'sections=' + encodeURIComponent(ids.join(',')), { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw CartError(t('error'), r.status); return r.json(); })
        .then(renderSections),
      fetchCart().then(function (cart) { setCount(cart.item_count); emit('mc2:cart:updated', { cart: cart, source: 'refresh' }); return cart; })
    ]).then(function (r) { return r[1]; });
  }
  function refresh() { return enqueue(refreshNow); }
  function note(text) {
    return enqueue(function () { return request('POST', 'cart/update.js', { note: String(text == null ? '' : text) }); });
  }
  function lineMessage(key, msg) {
    var line = $$('[data-mc2-line]').filter(function (l) { return l.getAttribute('data-mc2-line') === String(key); });
    var shown = false;
    line.forEach(function (l) { var m = $('[data-mc2-line-msg]', l); if (m) { m.textContent = msg; shown = true; } });
    if (!shown) $$('[data-mc2-cart-error]').forEach(function (m) { m.textContent = msg; });
    announce(msg);
  }

  /* ---------- modal manager (drawer + quick buy; one at a time; Back button closes) ---------- */
  var current = null; /* { name, el, panel, opener, onHide } */
  var carryOpener = null;
  var stateKey = 'mc2modal', pushed = false;
  /* a reload keeps history.state: drop a stale marker so Back never leaves the page by mistake */
  try { if (history.state && history.state[stateKey]) { var s0 = {}; for (var k0 in history.state) if (k0 !== stateKey) s0[k0] = history.state[k0]; history.replaceState(s0, ''); } } catch (e) {}
  function showModal(name, el, panel, onHide) {
    if (current && current.name !== name) hideModal(true);
    var opener = carryOpener || doc.activeElement;
    carryOpener = null;
    try {
      if (pushed) history.replaceState(withState(name), '');
      else { history.pushState(withState(name), ''); pushed = true; }
    } catch (e) {}
    current = { name: name, el: el, panel: panel, opener: opener, onHide: onHide };
    el.hidden = false;
    /* next frame so the slide transition runs; a timer fallback covers throttled tabs where frames stop */
    var opened = false;
    var openIt = function () { if (opened) return; opened = true; el.classList.add('is-open'); };
    requestAnimationFrame(openIt);
    setTimeout(openIt, 60);
    html.classList.add('mc2-lock');
    setTimeout(function () { var f = $('[data-mc2-autofocus]', panel) || panel; try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }, 30);
  }
  function withState(name) { var s = {}; var cur = history.state; if (cur && typeof cur === 'object') { for (var k in cur) s[k] = cur[k]; } s[stateKey] = name; return s; }
  /* keepHistory: switching modal (drawer ⇄ quick buy) keeps our history entry */
  function hideModal(keepHistory, restoreFocusTo) {
    if (!current) return;
    var c = current; current = null;
    c.el.classList.remove('is-open');
    var finish = function () { if (!current || current.el !== c.el) c.el.hidden = true; };
    if (reduceMotion) finish(); else setTimeout(finish, 330);
    if (c.onHide) c.onHide();
    if (keepHistory) carryOpener = c.opener;
    else {
      html.classList.remove('mc2-lock');
      var target = restoreFocusTo || c.opener;
      if (target && target.focus && doc.contains(target)) { try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); } }
    }
    return c;
  }
  function closeModal() {
    if (!current) return;
    if (pushed) { pushed = false; history.back(); } /* popstate hides it */
    else hideModal(false);
  }
  window.addEventListener('popstate', function (e) {
    if (!current) return;
    pushed = false;
    hideModal(false);
  });
  doc.addEventListener('keydown', function (e) {
    if (!current) return;
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); closeModal(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', current.panel)
      .filter(function (x) { return x.offsetWidth || x.offsetHeight || x.getClientRects().length; });
    if (!f.length) { e.preventDefault(); current.panel.focus(); return; }
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && (doc.activeElement === first || doc.activeElement === current.panel)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- drawer ---------- */
  function drawerEl() { return $('[data-mc2-drawer]'); }
  function openDrawer() {
    var el = drawerEl();
    if (!el) { window.location.href = url('cart'); return; }
    if (current && current.name === 'drawer') return;
    showModal('drawer', el, $('[data-mc2-drawer-panel]', el), function () { emit('mc2:cart:closed'); });
    emit('mc2:cart:opened');
  }
  function closeDrawer() { if (current && current.name === 'drawer') closeModal(); }

  /* ---------- quick buy ---------- */
  var qb = null, qbSeq = 0, qbCtrl = null;
  function qbShell() {
    if (qb) return qb;
    var el = doc.createElement('div');
    el.className = 'mc2 mc2-qb';
    el.hidden = true;
    el.setAttribute('data-mc2-qb', '');
    el.innerHTML = '<div class="mc2-qb__overlay" data-mc2-qb-close></div>' +
      '<div class="mc2-qb__panel" role="dialog" aria-modal="true" aria-labelledby="mc2-qb-title" tabindex="-1" data-mc2-qb-panel>' +
      '<div class="mc2-qb__grab" aria-hidden="true"></div><div class="mc2-qb__content" data-mc2-qb-content></div></div>';
    doc.body.appendChild(el);
    qb = { el: el, panel: $('[data-mc2-qb-panel]', el), content: $('[data-mc2-qb-content]', el) };
    return qb;
  }
  function qbStatus(text, link) {
    var s = qbShell();
    s.content.innerHTML = '';
    var box = doc.createElement('div'); box.className = 'mc2-qb__status';
    var h = doc.createElement('p'); h.id = 'mc2-qb-title'; h.setAttribute('role', 'status'); h.textContent = text; box.appendChild(h);
    if (link) { var a = doc.createElement('a'); a.className = 'mc2-btn mc2-btn--secondary'; a.href = link; a.textContent = t('details'); box.appendChild(a); }
    var x = doc.createElement('button'); x.type = 'button'; x.className = 'mc2-qb__x'; x.setAttribute('data-mc2-qb-close', ''); x.setAttribute('aria-label', t('close')); x.textContent = '×'; x.setAttribute('data-mc2-autofocus', '');
    box.appendChild(x);
    s.content.appendChild(box);
  }
  function openQuickBuy(handle, trigger) {
    if (!handle) return Promise.resolve();
    var s = qbShell();
    var fallback = (trigger && trigger.getAttribute('data-mc2-url')) || url('products/' + encodeURIComponent(handle));
    if (qbCtrl) { try { qbCtrl.abort(); } catch (e) {} }
    qbCtrl = window.AbortController ? new AbortController() : null;
    var my = ++qbSeq;
    qbStatus(t('loading'));
    s.content.setAttribute('aria-busy', 'true');
    showModal('qb', s.el, s.panel, function () { if (qbCtrl) { try { qbCtrl.abort(); } catch (e) {} } emit('mc2:quickbuy:closed', { handle: handle }); });
    if (trigger && trigger.closest && !trigger.closest('[data-mc2-drawer]')) current.opener = trigger;
    emit('mc2:quickbuy:opened', { handle: handle });
    return fetch(url('products/' + encodeURIComponent(handle)) + '?section_id=mc2-quick-buy', { credentials: 'same-origin', signal: qbCtrl ? qbCtrl.signal : undefined })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.text(); })
      .then(function (markup) {
        if (my !== qbSeq || !current || current.name !== 'qb') return;
        var tmp = doc.createElement('div'); tmp.innerHTML = markup;
        var node = $('[data-mc2-qb-root]', tmp);
        if (!node) throw new Error('no-section');
        s.content.innerHTML = '';
        s.content.appendChild(node);
        s.content.removeAttribute('aria-busy');
        initQuickBuy(node);
      })
      .catch(function (err) {
        if (my !== qbSeq || (err && err.name === 'AbortError')) return;
        s.content.removeAttribute('aria-busy');
        qbStatus(t('loadError'), fallback);
      });
  }
  function closeQuickBuy() { if (current && current.name === 'qb') closeModal(); }

  function initQuickBuy(rootEl) {
    var data;
    try { data = JSON.parse($('script[data-mc2-qb-json]', rootEl).textContent); } catch (e) { return; }
    var variants = data.variants || [], nOpt = data.options.length, L = data.labels || {};
    /* nothing is preselected; an option with a single value is not a choice, so it is set for the shopper */
    var sel = []; for (var i = 0; i < nOpt; i++) sel.push(data.options[i].values.length === 1 ? data.options[i].values[0] : null);
    var avail = variants.filter(function (v) { return v.available; });
    var addBtn = $('[data-mc2-qb-add]', rootEl), addLabel = $('[data-mc2-qb-add-label]', rootEl);
    var priceEl = $('[data-mc2-qb-price]', rootEl), msg = $('[data-mc2-qb-msg]', rootEl);
    var caption = $('[data-mc2-qb-caption]', rootEl);
    var img = $('[data-mc2-qb-media] img', rootEl), more = $('[data-mc2-qb-more]', rootEl);
    var baseUrl = more ? more.getAttribute('href').split('?')[0] : '';
    var defaultPrice = priceEl ? priceEl.innerHTML : '';
    var defaultImg = img ? { src: img.getAttribute('src'), srcset: img.getAttribute('srcset') } : null;

    function fits(v, skip) { for (var x = 0; x < nOpt; x++) { if (x === skip || sel[x] == null) continue; if (v.options[x] !== sel[x]) return false; } return true; }
    function match() { for (var x = 0; x < nOpt; x++) if (sel[x] == null) return null; for (var k = 0; k < variants.length; k++) if (fits(variants[k], -1)) return variants[k]; return null; }
    function exists(o, val) { return avail.some(function (v) { return v.options[o] === val; }); }
    function compatible(o, val) { return avail.some(function (v) { return v.options[o] === val && fits(v, o); }); }
    function consistent() { return avail.some(function (v) { return fits(v, -1); }); }
    function setImg(src, srcset) { if (!img || !src) return; img.setAttribute('src', src); if (srcset) img.setAttribute('srcset', srcset); else img.removeAttribute('srcset'); }

    function update() {
      $$('[data-mc2-qb-opt]', rootEl).forEach(function (fs) {
        var o = Number(fs.getAttribute('data-mc2-qb-opt'));
        $$('input[type="radio"]', fs).forEach(function (inp) {
          var ok = exists(o, inp.value), fit = ok && compatible(o, inp.value);
          inp.checked = sel[o] === inp.value;
          var lab = inp.nextElementSibling;
          if (lab) { lab.classList.toggle('is-sold', !ok); lab.classList.toggle('is-clash', ok && !fit); }
        });
        var shown = $('[data-mc2-qb-chosen="' + o + '"]', rootEl);
        if (shown) shown.textContent = sel[o] != null ? sel[o] : L.none;
      });
      var v = match();
      msg.textContent = '';
      msg.classList.remove('is-error');
      if (v && v.available) {
        addBtn.disabled = false;
        addBtn.removeAttribute('aria-disabled');
        addLabel.textContent = L.add;
        if (priceEl) priceEl.innerHTML = v.price_html;
        if (caption) caption.textContent = v.label + ' · ' + L.in_stock;
        if (v.image) setImg(v.image, v.srcset);
        if (more) more.href = baseUrl + '?variant=' + v.id;
      } else {
        addBtn.disabled = true;
        if (v && !v.available) addLabel.textContent = L.value_sold_out || L.sold_out;
        else if (!avail.length) addLabel.textContent = L.sold_out;
        else {
          var missing = 0; for (var x = 0; x < nOpt; x++) if (sel[x] == null) { missing = x; break; }
          addLabel.textContent = data.options[missing].choose_first;
        }
        if (priceEl) priceEl.innerHTML = v ? v.price_html : defaultPrice;
        if (caption) caption.textContent = '';
        var lead = null;
        if (sel[0] != null) { for (var k = 0; k < variants.length; k++) if (variants[k].options[0] === sel[0] && variants[k].image) { lead = variants[k]; break; } }
        if (lead) setImg(lead.image, lead.srcset); else if (defaultImg) setImg(defaultImg.src, defaultImg.srcset);
        if (more) more.href = baseUrl;
      }
    }
    $$('input[type="radio"]', rootEl).forEach(function (inp) {
      inp.addEventListener('change', function () {
        var o = Number(inp.closest('[data-mc2-qb-opt]').getAttribute('data-mc2-qb-opt'));
        sel[o] = inp.value;
        /* an in-stock value that clashes with another choice clears that choice instead of trapping the shopper;
           a sold-out value is shown as sold out and changes nothing else */
        if (exists(o, inp.value)) for (var x = 0; x < nOpt; x++) if (x !== o && sel[x] != null && !consistent()) sel[x] = null;
        update();
      });
    });
    addBtn.addEventListener('click', function () {
      var v = match();
      if (!v || !v.available || addBtn.classList.contains('is-loading')) return;
      addBtn.classList.add('is-loading'); addBtn.setAttribute('aria-busy', 'true');
      add([{ id: v.id, quantity: 1 }], { source: 'quickbuy', open: false }).then(function () {
        addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy');
        if (current && current.name === 'qb') {
          if ($('[data-mc2-main-cart]')) closeModal(); else { hideModal(true); openDrawer(); }
        }
      }, function (err) {
        addBtn.classList.remove('is-loading'); addBtn.removeAttribute('aria-busy');
        msg.textContent = err.message; msg.classList.add('is-error');
        announce(err.message);
      });
    });
    update();
    var xb = $('[data-mc2-autofocus]', rootEl);
    if (xb) { try { xb.focus({ preventScroll: true }); } catch (e) { xb.focus(); } }
  }

  /* ---------- card / generic add buttons ---------- */
  function cardMsg(btn, text) {
    var card = btn.closest('[data-mc2-card]') || btn.parentNode;
    var m = card && $('[data-mc2-msg]', card);
    if (!m) return;
    m.textContent = text;
    m.classList.toggle('is-error', !!text);
    clearTimeout(m._t);
    if (text) m._t = setTimeout(function () { m.textContent = ''; m.classList.remove('is-error'); }, 7000);
  }
  function addFromButton(btn) {
    if (btn.disabled || btn.classList.contains('is-loading')) return;
    var id = btn.getAttribute('data-mc2-add');
    if (!id) return;
    var label = $('[data-mc2-label]', btn);
    btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true');
    cardMsg(btn, '');
    add([{ id: id, quantity: btn.getAttribute('data-mc2-qty') || 1 }], { source: btn.getAttribute('data-mc2-source') || 'card' }).then(function () {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      if (label) {
        var old = label.textContent; label.textContent = t('added'); btn.classList.add('is-added');
        setTimeout(function () { label.textContent = old; btn.classList.remove('is-added'); }, 2400);
      }
    }, function (err) {
      btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy');
      cardMsg(btn, err.message);
    });
  }

  /* ---------- delegated events ---------- */
  doc.addEventListener('click', function (e) {
    var tgt = e.target;
    if (!tgt || !tgt.closest) return;
    var el;
    if ((el = tgt.closest('[data-mc2-cart-open]'))) { if (drawerEl() && !$('[data-mc2-main-cart]')) { e.preventDefault(); openDrawer(); } return; }
    if ((el = tgt.closest('[data-mc2-cart-close]'))) { e.preventDefault(); closeDrawer(); return; }
    if ((el = tgt.closest('[data-mc2-qb-close]'))) { e.preventDefault(); closeQuickBuy(); return; }
    if ((el = tgt.closest('[data-mc2-quickbuy]'))) { e.preventDefault(); openQuickBuy(el.getAttribute('data-mc2-quickbuy'), el); return; }
    if ((el = tgt.closest('[data-mc2-add]'))) { e.preventDefault(); addFromButton(el); return; }
    if ((el = tgt.closest('[data-mc2-line-step]'))) {
      e.preventDefault();
      if (el.disabled || el.getAttribute('aria-disabled') === 'true') return;
      var line = el.closest('[data-mc2-line]');
      if (!line) return;
      var input = $('[data-mc2-line-input]', line);
      var base = line._mc2Target != null ? line._mc2Target : (parseInt(line.getAttribute('data-mc2-qty'), 10) || 1);
      var next = Math.max(1, base + Number(el.getAttribute('data-mc2-line-step')));
      if (next === base) return;
      line._mc2Target = next;
      if (input) input.value = String(next);
      var minus = $('[data-mc2-line-step="-1"]', line);
      if (minus) minus.disabled = next <= 1;
      line.classList.add('is-busy');
      clearTimeout(line._mc2T);
      line._mc2T = setTimeout(function () { change(line.getAttribute('data-mc2-line'), next).catch(function () {}); }, 350);
      return;
    }
    if ((el = tgt.closest('[data-mc2-line-remove]'))) {
      e.preventDefault();
      var l2 = el.closest('[data-mc2-line]');
      if (!l2) return;
      l2.classList.add('is-busy', 'is-removing');
      change(l2.getAttribute('data-mc2-line'), 0).catch(function () {});
      return;
    }
  });
  /* checkout: wait for pending writes so the checkout never starts from a stale quantity */
  doc.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.hasAttribute && f.hasAttribute('data-mc2-checkout-form') && (pending > 0 || f.querySelector('.mc2-line.is-busy'))) {
      e.preventDefault(); heldForm = f;
      /* a quantity tap still in its short debounce, or a stale busy mark: never hold checkout for long */
      setTimeout(function () { if (!pending) flushCheckout(); }, 1200);
      return;
    }
    if (f && f.hasAttribute && f.hasAttribute('data-mc2-ajax-form')) {
      if (f.querySelector('input[type="file"]')) return; /* native submit for uploads */
      e.preventDefault();
      var fd = new FormData(f), item = { id: fd.get('id'), quantity: fd.get('quantity') || 1 }, props = {}, hasProps = false;
      fd.forEach(function (v, k) { var m = /^properties\[(.+)\]$/.exec(k); if (m && v !== '') { props[m[1]] = v; hasProps = true; } });
      if (hasProps) item.properties = props;
      if (fd.get('selling_plan')) item.selling_plan = fd.get('selling_plan');
      var btn = f.querySelector('[type="submit"]'), errBox = f.querySelector('[data-mc2-form-error]');
      if (!item.id) return;
      if (btn) { btn.classList.add('is-loading'); btn.setAttribute('aria-busy', 'true'); }
      if (errBox) errBox.textContent = '';
      add([item], { source: 'pdp' }).then(function () {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      }, function (err) {
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
        if (errBox) errBox.textContent = err.message; else announce(err.message);
      });
    }
  });
  /* Enter in a line quantity applies it instead of submitting the checkout form */
  doc.addEventListener('keydown', function (e) {
    var n = e.target;
    if (e.key === 'Enter' && n && n.hasAttribute && n.hasAttribute('data-mc2-line-input')) { e.preventDefault(); n.blur(); /* blur fires the native change event */ }
  });
  /* order note: saved when the shopper leaves the field (also posted with the checkout form) */
  doc.addEventListener('change', function (e) {
    var n = e.target;
    if (n && n.hasAttribute && n.hasAttribute('data-mc2-line-input')) {
      var ln = n.closest('[data-mc2-line]');
      var q = parseInt(n.value, 10);
      if (!ln) return;
      if (!(q >= 1)) { n.value = ln.getAttribute('data-mc2-qty'); return; }
      q = Math.min(999, q);
      ln.classList.add('is-busy');
      change(ln.getAttribute('data-mc2-line'), q).catch(function () {});
      return;
    }
    if (n && n.hasAttribute && n.hasAttribute('data-mc2-note')) {
      var st = n.closest('[data-mc2-note-wrap]'), out = st && $('[data-mc2-note-status]', st);
      note(n.value).then(function () { if (out) out.textContent = t('noteSaved'); }, function (err) { if (out) out.textContent = err.message; });
    }
  });
  /* bfcache: a page restored from history refreshes the bag instead of reloading */
  window.addEventListener('pageshow', function (e) { if (e.persisted) refresh().catch(function () {}); });

  MC2.cart = { __mc2: true, add: add, change: change, open: openDrawer, close: closeDrawer, refresh: refresh, note: note, get busy() { return pending > 0; } };
  MC2.quickBuy = { open: function (handle) { return openQuickBuy(handle, doc.activeElement); }, close: closeQuickBuy };
})();
